import {ReactNode} from 'react';

import {
  InlineDataComponentRegistry,
  InlineDataProvider as Provider,
} from '@stripe-internal/inline-data';

import {useApp} from '../hooks/appHooks';

type Props = {
  components?: InlineDataComponentRegistry;
  children: ReactNode;
};

// Should be provided within the conversations-assistant app context
export function InlineDataProvider({components = {}, children}: Props) {
  const app = useApp();
  return (
    <Provider
      bus={app.inlineDataEventBus}
      value={{service: app.inlineDataService, components}}
    >
      {children}
    </Provider>
  );
}
